import React from 'react';
import { BasicRadioGroup } from '../../basic-inputs';
import { TooltipPosition, TooltipSize } from '../../tooltip';
import FormField from '../FormField';
import { FormFieldProps } from '../types';

interface GroupProps {
  inline?: boolean;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  errorMessage?: string;
  helpText?: string;
  helpTextPosition?: 'after-label' | 'below-field';
  helperTextToolTipConfig?: {
    size?: TooltipSize;
    position?: TooltipPosition;
  };
}

type Props = FormFieldProps & GroupProps;

type GroupFieldProps =
  | ({ name: string } & GroupProps)
  | ({ name: string } & GroupProps & FormFieldProps);
const RadioGroup: React.FC<Props> = props => <BasicRadioGroup {...props} />;

const RadioGroupField: React.FC<GroupFieldProps> = props => (
  <FormField component={RadioGroup} {...props} />
);

export default RadioGroupField;
